<template>
  <i class="material-icons-round"
    v-bind:class="{
      active: !val,
      deactive: val,
    }">
    {{val ? deactiveLabel : activeLabel}}
  </i>
</template>

<script>
export default {
  props: ['val', 'activeLabel', 'deactiveLabel'],
};
</script>

<style lang="scss" scoped>
.deactive {
  color: rgb(51, 167, 51);
}
.active {
  color: rgb(128, 128, 128);
}
</style>
